/*@ngInject*/
const UICustomPrintTitleDirective = function ($window, $document, localization) {


    let linkFunction = function ($scope, $elm) {

        localization.getTranslationByKey('customPrintPageTitle').then((result) => {
            let hasCustomPrintPageTitle = result;

            if(hasCustomPrintPageTitle) {
                const previousTitle = $document[0].title;

                function beforePrint() {
                    $document[0].title = hasCustomPrintPageTitle;
                }

                function afterPrint() {
                    $document[0].title = previousTitle;
                }

                $window.addEventListener('beforeprint', beforePrint);
                $window.addEventListener('afterprint', afterPrint);

                $scope.$on('$destroy', function () {
                    $window.removeEventListener('beforeprint', beforePrint);
                    $window.removeEventListener('afterprint', afterPrint);
                });
            }
        });

    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiCustomPrintTitle', UICustomPrintTitleDirective);
